module.exports = __webpack_public_path__ + "static/media/flag_cn.c17d5fc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/flashcard/flag_cn.svg
// module id = 128
// module chunks = 0